module.exports = __webpack_public_path__ + "img/workflow.d95e248b.svg";